export const getInitialState = (): any => ({
  storageData: [],
  storageStatus: 0
});
